export default __webpack_public_path__ + "static/media/woodlands-logo.1a5ed525.png";